const MODULE = "REPRESSION_PEOPLE";

export const GET_PEOPLE = `${MODULE}get-people`;
export type GET_PEOPLE = typeof GET_PEOPLE;

export const CHANGE_VALUE = `${MODULE}change-value`;
export type CHANGE_VALUE = typeof CHANGE_VALUE;